import React, { memo } from 'react';
import { Row, Col } from 'reactstrap';
import { Tooltip } from '@material-ui/core';
import Loader from 'react-loader-spinner';
import csvIcon from 'assets/img/csv.png';
import xlsxIcon from 'assets/img/xlsx.png';

const ImageButtonContainer = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginRight: '15px'
};

const ImageButton = {
  background: 'none',
  border: 'none',
  padding: '5px',
  cursor: 'pointer'
};

const ImageSize = {
  width: '42px',
  height: '42px'
};

export const DownloadButtons = memo(
  ({
    disabled,
    onCsvClick,
    onXlsxClick,
    downloading,
    downloadType,
    csvTooltip,
    xlsxTooltip
  }) => (
    <Row className="mb-3">
      <Col style={ImageButtonContainer}>
        <button
          type="button"
          disabled={disabled}
          style={ImageButton}
          onClick={onCsvClick}
        >
          <Tooltip
            title={<p style={{ fontSize: '14px' }}>{csvTooltip}</p>}
            arrow
          >
            {downloading && downloadType === 'csv' ? (
              <Loader type="ThreeDots" visible={true} height="40" width="40" />
            ) : (
              <img src={csvIcon} alt="Download CSV" style={ImageSize} />
            )}
          </Tooltip>
        </button>

        <button
          type="button"
          disabled={disabled}
          style={ImageButton}
          onClick={onXlsxClick}
        >
          <Tooltip
            title={<p style={{ fontSize: '14px' }}>{xlsxTooltip}</p>}
            arrow
          >
            {downloading && downloadType === 'xlsx' ? (
              <Loader type="ThreeDots" visible={true} height="40" width="40" />
            ) : (
              <img src={xlsxIcon} alt="Download XLSX" style={ImageSize} />
            )}
          </Tooltip>
        </button>
      </Col>
    </Row>
  )
);

DownloadButtons.displayName = 'DownloadButtons';
